// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tScx","buttons":"styles_buttons__3MsbG"};